.button {
  // Reset
  border: none;
  background: none;
  margin: 0;
  cursor: pointer;

  // Layout
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  // Typography
  font-family: $font-family-base;
  font-weight: map.get($font-weights, 'medium');
  text-align: center;
  white-space: nowrap;

  // Border radius
  border-radius: map.get($radius, 'md');

  // Transitions
  @include transition(background-color, color, transform, box-shadow);

  &:focus-visible {
    @include focus-ring;
  }

  &:active:not(.disabled) {
    transform: translateY(1px);
  }
}

// Size variants
.large {
  height: 52px;
  padding: 16px;
  @include body-medium;
}

.regular {
  height: 44px;
  padding: 12px 16px;
  @include body-medium;
}

.small {
  height: 38px;
  padding: 10px 16px;
  @include body-small-medium;
}

// Primary variant
.primary {
  background-color: var(--color-primary-base);
  color: var(--color-primary-on-primary);

  &:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(95, 91, 243, 0.3);
  }

  &:active:not(.disabled) {
    opacity: 0.8;
    transform: translateY(0);
  }
}

// Secondary variant
.secondary {
  background-color: transparent;
  color: var(--color-text-primary);
  border: 1px solid var(--color-grey-neutral);

  &:hover:not(.disabled) {
    background-color: var(--color-surface-alt);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:active:not(.disabled) {
    background-color: var(--color-surface-alt);
    transform: translateY(0);
  }
}

// Text variant
.text {
  background-color: transparent;
  color: var(--color-text-primary);
  padding-left: map.get($spacing-scale, 'sm');
  padding-right: map.get($spacing-scale, 'sm');

  &:hover:not(.disabled) {
    background-color: var(--color-primary-opacity-08);
  }

  &:active:not(.disabled) {
    opacity: 0.4;
  }
}

// Warning variant (orange/yellow background)
.warning {
  background-color: var(--color-semantic-warning);
  color: var(--color-text-primary);

  &:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  }

  &:active:not(.disabled) {
    opacity: 0.8;
    transform: translateY(0);
  }
}

// Danger variant (red text, transparent background)
.danger {
  background-color: transparent;
  color: var(--color-semantic-danger);
  border: 1px solid var(--color-semantic-danger);

  &:hover:not(.disabled) {
    background-color: rgba(239, 68, 68, 0.08);
    transform: translateY(-1px);
  }

  &:active:not(.disabled) {
    opacity: 0.8;
    transform: translateY(0);
  }
}

// Disabled state
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

// Icon styling
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg,
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.large .icon {
  width: 20px;
  height: 20px;
}

.regular .icon {
  width: 20px;
  height: 20px;
}

.small .icon {
  width: 18px;
  height: 18px;
}

// Text span (renamed to avoid collision with .text variant)
.buttonText {
  display: inline-block;
  color: inherit; // Inherit color from parent button
}
